export default __webpack_public_path__ + "static/media/clouds-white.c7c7a895.png";